import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Home, GraduationCap, PencilRuler, MonitorPlay } from "lucide-react";

const TABS = [
  { to: "/", key: "home", Icon: Home },
  { to: "/learn", key: "learn", Icon: GraduationCap },
  { to: "/workspace", key: "workspace", Icon: PencilRuler },
  { to: "/simulator", key: "simulator", Icon: MonitorPlay },
];

export default function BottomNav() {
  const { t } = useTranslation();
  const location = useLocation();
  const isActive = (to) => (to === "/" ? location.pathname === "/" : location.pathname.startsWith(to));
  const activeIndex = TABS.findIndex(({ to }) => isActive(to));

  return (
    <nav
      data-testid="bottom-nav"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 border-t border-white/10 bg-[#0B132B]/95 backdrop-blur-xl pb-[env(safe-area-inset-bottom)]"
    >
      <div className="relative grid grid-cols-4">
        {/* Sliding active-tab indicator */}
        {activeIndex >= 0 && (
          <span
            aria-hidden
            data-testid="bottomnav-indicator"
            className="absolute top-0 h-0.5 bg-primary rounded-full transition-transform duration-300 ease-out"
            style={{ width: "25%", transform: `translateX(${activeIndex * 100}%)` }}
          />
        )}
        {TABS.map(({ to, key, Icon }) => {
          const active = isActive(to);
          return (
            <Link
              key={to}
              to={to}
              aria-current={active ? "page" : undefined}
              data-testid={`bottomnav-${key}`}
              className={`flex flex-col items-center justify-center gap-0.5 py-2.5 text-[11px] font-medium transition-colors duration-200 ${
                active ? "text-primary" : "text-slate-400 hover:text-white"
              }`}
            >
              <Icon size={20} className={active ? "scale-110 transition-transform duration-200" : "transition-transform duration-200"} />
              <span>{t(`nav.${key}`)}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
